module.exports = __webpack_public_path__ + "img/insurance-providers.bf29c23a.png";